import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=5d3083bc&scoped=true&"
import script from "./LottieLoader.vue?vue&type=script&lang=ts&"
export * from "./LottieLoader.vue?vue&type=script&lang=ts&"
import style0 from "./LottieLoader.vue?vue&type=style&index=0&id=5d3083bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3083bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3083bc')) {
      api.createRecord('5d3083bc', component.options)
    } else {
      api.reload('5d3083bc', component.options)
    }
    module.hot.accept("./LottieLoader.vue?vue&type=template&id=5d3083bc&scoped=true&", function () {
      api.rerender('5d3083bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Lottie/LottieLoader.vue"
export default component.exports